<script>
export default {
  data() {
    return {
      activeTab: 1
    }
  }
}
</script>
